export enum IdentityProvider {
  MONS = 'MONS',
}
